import React from "react";
import { RouteProps } from "react-router-dom";
import { useCurrentRouteData } from "../../services/app-state";
import { HeroPage } from "../organisms/HeroPage";
import { PageWrapper } from "../organisms/PageWrapper";
import { SavedItemsContent } from "../organisms/SavedItemsContent";

export const SavedItemsTemplate: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData();
    return (
        <>
            <HeroPage title={page.title.rendered} />
            <PageWrapper>
                <SavedItemsContent />
            </PageWrapper>
        </>
    );
};
